import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { SectionEyebrow } from '../SectionEyebrow';
const Particles: React.FC = () => <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 800 400" fill="none" data-id="element-324">
    {Array.from({
    length: 40
  }).map((_, i) => {
    const startX = Math.random() * 800;
    const startY = Math.random() * 400;
    const endX = 400 + (Math.random() - 0.5) * 60;
    const endY = 200 + (Math.random() - 0.5) * 30;
    return <motion.circle key={i} r={Math.random() * 1.6 + 0.6} fill="#D4AF7A" initial={{
      cx: startX,
      cy: startY,
      opacity: 0
    }} whileInView={{
      cx: endX,
      cy: endY,
      opacity: [0, 0.7, 0.3]
    }} viewport={{
      once: true
    }} transition={{
      duration: 4,
      delay: i * 0.05,
      ease: 'easeInOut'
    }} data-id="element-325" />;
  })}
  </svg>;
export const Problem: React.FC = () => <section className="relative bg-navy-deep py-28 lg:py-44 overflow-hidden" data-id="element-326">
    <div className="absolute inset-0" style={{
    background: 'radial-gradient(ellipse at center, rgba(107,91,149,0.18), transparent 60%)'
  }} data-id="element-327" />
    <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-328">
      <Reveal data-id="element-329">
        <SectionEyebrow data-id="element-330">El conflicto interior</SectionEyebrow>
      </Reveal>

      <Reveal delay={0.1} data-id="element-331">
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl leading-[1.1] text-ivory text-balance mb-12" style={{
        fontWeight: 300
      }} data-id="element-332">
          Cuando una parte de ti avanza,
          <br className="hidden md:block" data-id="element-333" />
          <span className="italic gold-text" style={{
          fontWeight: 400
        }} data-id="element-334">
            pero otra se siente perdida.
          </span>
        </h2>
      </Reveal>

      <div className="relative h-[200px] my-12 hidden md:block" data-id="element-335">
        <Particles data-id="element-336" />
      </div>

      <div className="space-y-8 text-ivory/75 text-lg leading-[1.85] font-light max-w-2xl mx-auto" data-id="element-337">
        <Reveal delay={0.1} data-id="element-338">
          <p data-id="element-339">
            Muchas personas intentan mejorar su vida desde una sola dimensión.
            Trabajan más. Se exigen más. Buscan motivación. Intentan cambiar
            hábitos. Pero aun así sienten que algo no termina de encajar.
          </p>
        </Reveal>
        <Reveal delay={0.15} data-id="element-340">
          <p className="font-serif italic text-2xl lg:text-3xl text-gold/90 leading-snug py-4" style={{
          fontWeight: 400
        }} data-id="element-341">
            A veces el problema no es falta de fuerza.
            <br data-id="element-342" />A veces es falta de integración.
          </p>
        </Reveal>
        <Reveal delay={0.2} data-id="element-343">
          <div className="grid sm:grid-cols-2 gap-x-10 gap-y-3 text-base text-ivory/65 max-w-xl mx-auto py-4 text-center sm:text-left" data-id="element-344">
            <p data-id="element-345">· Tu cuerpo puede estar cansado.</p>
            <p data-id="element-346">· Tus emociones pueden estar desordenadas.</p>
            <p data-id="element-347">· Tu mente puede estar saturada.</p>
            <p data-id="element-348">· Tus relaciones, desconectadas.</p>
            <p className="sm:col-span-2 sm:text-center" data-id="element-349">
              · Tu propósito puede sentirse borroso.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.25} data-id="element-350">
          <p data-id="element-351">
            <span className="font-serif italic text-ivory" data-id="element-352">
              La Estabilidad Dimensional de Nuestro Ser
            </span>{' '}
            nace como una guía para volver a unir esas partes. No desde la
            presión. No desde la culpa. Sino desde una mirada más consciente,
            profunda y humana.
          </p>
        </Reveal>
      </div>
    </div>
  </section>;